import {CHANGE_COMMENT} from './actions';

export const setComment = comment => ({
    type: CHANGE_COMMENT,
    comment: comment
});


// WEBPACK FOOTER //
// ./src/app/actions/changeComm.js